import "core-js/modules/es.function.name.js";

/* eslint-disable camelcase */
import React from 'react';
import { ColorBatch, Button } from 'components';
import { dateFormat, reportStatusColorMap, reportStatusName, REPORT_STATUS } from 'enums';
import { actionsWrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var requested = REPORT_STATUS.requested,
    sent = REPORT_STATUS.sent,
    confirmed = REPORT_STATUS.confirmed,
    rejected = REPORT_STATUS.rejected;
var buttonTypes = {
  sent: {
    name: 'Изпрати',
    type: 'info',
    status: sent
  },
  sendReport: {
    name: 'Изпрати отчет',
    type: 'warning',
    status: sent
  },
  confirmed: {
    name: 'Потвърди',
    type: 'success',
    status: confirmed
  },
  rejected: {
    name: 'Откажи',
    type: 'primary',
    status: rejected
  }
};
export var reportRequestColumns = function reportRequestColumns(roleData, onSendRequest) {
  var isTenantManager = roleData.isTenantManager,
      isFranchiseeOwner = roleData.isFranchiseeOwner,
      isOfficeManager = roleData.isOfficeManager;

  var reportButton = function reportButton(id, status) {
    var config = buttonTypes[status];
    return ___EmotionJSX(Button, {
      small: true,
      type: config === null || config === void 0 ? void 0 : config.type,
      onClick: function onClick() {
        return onSendRequest(id, {
          status: config === null || config === void 0 ? void 0 : config.status
        });
      }
    }, config === null || config === void 0 ? void 0 : config.name);
  };

  var renderActionButton = function renderActionButton(data) {
    var isOffice = !!(data !== null && data !== void 0 && data.office_id);
    var id = data === null || data === void 0 ? void 0 : data.id;

    switch (true) {
      case isTenantManager && (data === null || data === void 0 ? void 0 : data.status) === requested:
        return reportButton(id, rejected);

      case isFranchiseeOwner && (data === null || data === void 0 ? void 0 : data.status) === requested && !isOffice:
        return ___EmotionJSX("div", {
          css: actionsWrap
        }, reportButton(id, sent), reportButton(id, rejected));

      case isFranchiseeOwner && (data === null || data === void 0 ? void 0 : data.status) === requested && isOffice:
        return ___EmotionJSX("div", {
          css: actionsWrap
        }, reportButton(id, rejected), reportButton(id, 'sendReport'));

      case isOfficeManager && (data === null || data === void 0 ? void 0 : data.status) === requested:
        return ___EmotionJSX("div", {
          css: actionsWrap
        }, reportButton(id, sent), reportButton(id, rejected));

      case isFranchiseeOwner && (data === null || data === void 0 ? void 0 : data.status) === sent && isOffice:
        return reportButton(id, confirmed);

      case isTenantManager && (data === null || data === void 0 ? void 0 : data.status) === sent:
        return reportButton(id, confirmed);

      default:
        return null;
    }
  };

  return [{
    name: 'Име',
    render: function render(_ref) {
      var franchisee = _ref.franchisee,
          office = _ref.office;
      return ___EmotionJSX("span", null, office ? office === null || office === void 0 ? void 0 : office.name : franchisee === null || franchisee === void 0 ? void 0 : franchisee.name);
    }
  }, {
    name: 'Заявен на',
    value: 'request_date',
    dateTimeFormat: dateFormat,
    width: '120px'
  }, {
    name: 'Изпратен на',
    value: 'sent_date',
    dateTimeFormat: dateFormat,
    width: '120px'
  }, {
    name: 'Потвърден на',
    value: 'confirmed_date',
    dateTimeFormat: dateFormat,
    width: '120px'
  }, {
    name: 'Сума',
    render: function render(_ref2) {
      var amount = _ref2.amount,
          currency = _ref2.currency;
      return ___EmotionJSX("span", null, amount, " ", currency);
    }
  }, {
    name: 'Статус',
    render: function render(_ref3) {
      var status = _ref3.status;
      return ___EmotionJSX(ColorBatch, {
        type: reportStatusColorMap[status]
      }, reportStatusName[status]);
    },
    width: '130px'
  }, {
    name: 'Действие',
    render: function render(data) {
      return renderActionButton(data);
    },
    width: '160px'
  }];
};